export const CHAIN_CONFIG = {
  TON: {
    name: 'TON',
    icon: '◇',
    symbol: 'TON',
    color: '#2B5AFF',
    decimals: 9,
    testnet: {
      name: 'TON Testnet',
      rpcUrl: 'https://testnet.toncenter.com/api/v2/jsonRPC',
      explorer: 'https://testnet.tonscan.org',
      chainId: '0x1'
    },
    mainnet: {
      name: 'TON Mainnet',
      rpcUrl: 'https://toncenter.com/api/v2/jsonRPC',
      explorer: 'https://tonscan.org',
      chainId: '0x1'
    },
    features: {
      swap: true,
      stake: true,
      nft: true,
      dapps: true
    },
    tokenStandard: 'Jetton',
    gasToken: 'TON',
    minGasAmount: '0.1'
  },
  BNB: {
    name: 'BNB Chain',
    icon: 'BNB',
    symbol: 'BNB',
    color: '#F3BA2F',
    decimals: 18,
    testnet: {
      name: 'BNB Testnet',
      chainId: '0x61',
      rpcUrl: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
      explorer: 'https://testnet.bscscan.com',
      nativeCurrency: {
        name: 'BNB',
        symbol: 'tBNB',
        decimals: 18
      }
    },
    mainnet: {
      name: 'BNB Smart Chain',
      chainId: '0x38',
      rpcUrl: 'https://bsc-dataseed.binance.org/',
      explorer: 'https://bscscan.com',
      nativeCurrency: {
        name: 'BNB',
        symbol: 'BNB',
        decimals: 18
      }
    },
    features: {
      swap: true,
      stake: true,
      nft: true,
      dapps: true
    },
    tokenStandard: 'BEP20',
    gasToken: 'BNB',
    minGasAmount: '0.01'
  },
  EGC: {
    name: 'EGoldChain',
    icon: 'XAU',
    symbol: 'XAU',
    color: '#D4AF37', // Gold color
    decimals: 18,
    testnet: {
      name: 'EGoldChain Testnet',
      chainId: '0x52C3', // 21187 in hex
      rpcUrl: 'https://rpc-testnet.egoldchain.com',
      explorer: 'https://testnet.egoldscan.io',
      nativeCurrency: {
        name: 'EGold Testnet',
        symbol: 'XAU',
        decimals: 18
      }
    },
    mainnet: {
      name: 'EGoldChain',
      chainId: '0x4A3', // 1187 in hex
      rpcUrl: 'https://rpc.egoldchain.com',
      explorer: 'https://explorer.egoldchain.com',
      nativeCurrency: {
        name: 'EGold',
        symbol: 'XAU',
        decimals: 18
      }
    },
    features: {
      swap: true,
      stake: true,
      nft: false,
      dapps: true
    },
    tokenStandard: 'ERC20',
    gasToken: 'XAU',
    minGasAmount: '0.01'
  }
};

export const getChainConfig = (chainId) => {
  if (!chainId || typeof chainId !== 'string') {
    console.warn('Invalid chain ID provided to getChainConfig');
    return null;
  }

  const normalizedChainId = chainId.toUpperCase();
  const config = CHAIN_CONFIG[normalizedChainId];

  if (!config) {
    console.warn(`Chain configuration not found for ${chainId}`);
    return null;
  }

  return {
    ...config,
    // Ensure required fields have default values
    decimals: config.decimals || 18,
    minGasAmount: config.minGasAmount || '0',
    features: config.features || [],
    testnet: {
      rpcUrl: config.testnet?.rpcUrl || '',
      explorer: config.testnet?.explorer || '',
      chainId: config.testnet?.chainId || '',
      ...config.testnet
    },
    mainnet: {
      rpcUrl: config.mainnet?.rpcUrl || '',
      explorer: config.mainnet?.explorer || '',
      chainId: config.mainnet?.chainId || '',
      ...config.mainnet
    }
  };
};

export const getChainFeatures = (chainId) => {
  return CHAIN_CONFIG[chainId]?.features || {};
};

export const getChainNetwork = (chainId, isTestnet = false) => {
  return isTestnet ? CHAIN_CONFIG[chainId]?.testnet : CHAIN_CONFIG[chainId]?.mainnet;
};

export const getChainExplorer = (chainId, isTestnet = false) => {
  return getChainNetwork(chainId, isTestnet)?.explorer;
};

export const getChainRpcUrl = (chainId, isTestnet = false) => {
  return getChainNetwork(chainId, isTestnet)?.rpcUrl;
};

export const getMinGasAmount = (chainId) => {
  if (!chainId || typeof chainId !== 'string') {
    console.warn('Invalid chain ID provided to getMinGasAmount');
    return '0';
  }

  const config = getChainConfig(chainId);
  return config?.minGasAmount || '0';
};

export const getTokenStandard = (chainId) => {
  return CHAIN_CONFIG[chainId]?.tokenStandard;
};

export const SUPPORTED_CHAINS = Object.keys(CHAIN_CONFIG); 